<!-- eslint-disable @angular-eslint/template/alt-text -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="invite-page">

  <!-- ================= INVITE NO LONGER VALID (expired / not found) ================= -->
  <div class="intro-wrap" *ngIf="inviteInvalid">
    <div class="intro-inner" style="text-align: center; padding: 3rem 1rem;">
      <h2>This invite link is no longer valid</h2>
      <p>{{ inviteInvalidMessage }}</p>
      <p>Please contact the academy to request a new invite.</p>
    </div>
  </div>

  <!-- ================= ALREADY COMPLETED (password already set) ================= -->
  <div class="intro-wrap" *ngIf="alreadyCompleted">
    <div class="intro-inner" style="text-align: center; padding: 3rem 1rem;">
      <h2>You've already completed registration</h2>
      <p>Your account is already set up — please sign in instead.</p>
    </div>
  </div>

  <!-- ============================ STEP 0 — INTRO / LANDING ============================ -->
  <div class="intro-wrap" *ngIf="current_step === 0 && !inviteInvalid && !alreadyCompleted">
    <div class="intro-inner">
      <!-- Loading skeleton -->
      <ng-container *ngIf="loadingIntro; else introContent">
        <div style="text-align: center; padding: 3rem 1rem;">
          <!-- Logo -->
          <app-skeleton-loader type="circle" [width]="64" [height]="64" style="margin: 0 auto 1.25rem;"></app-skeleton-loader>
          <!-- Title -->
          <app-skeleton-loader type="rectangle" [height]="40" style="max-width: 450px; margin: 0 auto 0.35rem;"></app-skeleton-loader>
          <!-- Subtitle -->
          <app-skeleton-loader type="line" [height]="18" style="max-width: 350px; margin: 0 auto 1.5rem;"></app-skeleton-loader>
          <!-- Video (16:9 aspect ratio) -->
          <app-skeleton-loader type="rectangle" [height]="285" style="margin: 0 -1rem 1.5rem; width: calc(100% + 2rem);"></app-skeleton-loader>
          <!-- Detected box (card) -->
          <app-skeleton-loader type="rectangle" [height]="110" style="margin: 0 -1rem 1.5rem; width: calc(100% + 2rem);"></app-skeleton-loader>
          <!-- Button -->
          <app-skeleton-loader type="rectangle" [height]="50" style="margin: 0 -1rem 1rem; width: calc(100% + 2rem);"></app-skeleton-loader>
          <!-- Footer notes -->
          <app-skeleton-loader type="line" [height]="14" style="max-width: 280px; margin: 0 auto 0.5rem;"></app-skeleton-loader>
          <!-- Badges -->
          <div style="display: flex; justify-content: center; gap: 1rem; margin: 0 0 0.75rem;">
            <app-skeleton-loader type="rectangle" [width]="80" [height]="20"></app-skeleton-loader>
            <app-skeleton-loader type="rectangle" [width]="80" [height]="20"></app-skeleton-loader>
            <app-skeleton-loader type="rectangle" [width]="120" [height]="20"></app-skeleton-loader>
          </div>
          <!-- Resume note -->
          <app-skeleton-loader type="line" [height]="12" style="max-width: 320px; margin: 0 auto;"></app-skeleton-loader>
        </div>
      </ng-container>

      <ng-template #introContent>
        <img [src]="academy_dp" (error)="onImgError($event)" class="intro-logo" />
        <h1 class="intro-title">Reserve {{ invite_child ? (invite_child | titlecase) : 'Your Child' }}'s spot!</h1>
        <p class="intro-sub">Join {{ academy_name ? (academy_name | titlecase) : 'the Academy' }}</p>

        <!-- Coach welcome video (placeholder) -->
         
        <!-- <div class="video-box">
          <iframe [src]="coachVideoUrl" title="Coach Welcome Video" frameborder="0"
            allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </div> -->

        <!-- We detected … (editable) -->
        <div class="detected-box">
          <div class="detected-head">
            <div>
              <div class="detected-name">We detected: {{ invite_parent ? (invite_parent | titlecase) : 'Guest' }}</div>
              <div class="detected-q" *ngIf="!edit_detected">Is this correct?</div>
            </div>
            <i class="bi bi-pencil detected-edit" *ngIf="!edit_detected" (click)="toggleEditDetected()"></i>
          </div>

          <div class="detected-edit-view" *ngIf="edit_detected">
            <label class="col-form-label">Parent name</label>
            <input type="text" class="form-control" [(ngModel)]="detected_parent" placeholder="Parent name" />
            <label class="col-form-label mt-2">Child name</label>
            <input type="text" class="form-control" [(ngModel)]="detected_child" placeholder="Child name" />
            <button matRipple type="button" class="btn btn-primary w-100 main-height mt-3" (click)="updateDetected()">Update</button>
          </div>
        </div>

        <button matRipple type="button" class="btn btn-primary w-100 start-btn wizard-btn" (click)="startRegistration()">
          Start registration →
        </button>
        <p class="intro-note">Takes less than 2 minutes to complete</p>
        <div class="intro-badges">
          <span>✓ Secure</span><span>✓ Fast</span><span>✓ Mobile-friendly</span>
        </div>
        <p class="intro-resume">Already started? This link will resume your progress.</p>
      </ng-template>
    </div>
  </div>

  <!-- ======================= STEPS 1-3 — shared header ======================= -->
  <div *ngIf="current_step > 0 && current_step < 4">
    <div class="wizard-header">
      <img [src]="academy_dp" (error)="onImgError($event)" class="wizard-logo" />
      <div class="wizard-title">Complete registration for {{ invite_child ? (invite_child | titlecase) : 'Your Child' }}</div>
      <div class="wizard-progress">
        <span class="dot" [class.active]="current_step >= 1"></span>
        <span class="bar" [class.active]="current_step >= 2"></span>
        <span class="dot" [class.active]="current_step >= 2"></span>
        <span class="bar" [class.active]="current_step >= 3"></span>
        <span class="dot" [class.active]="current_step >= 3"></span>
      </div>
      <div class="wizard-step-label">Step {{ current_step }} of 3</div>
    </div>
  </div>

  <!-- ============================ STEP 1 — DETAILS (reused self-registration form) ============================ -->
  <div class="details-wrap" *ngIf="current_step === 1 && !inviteInvalid && !alreadyCompleted">
    <!-- Loading skeleton -->
    <ng-container *ngIf="loadingForm; else formContent">
      <div class="card mt-3">
        <div class="card-body">
          <app-skeleton-loader type="rectangle" [height]="28" class="mb-3" style="max-width: 200px;"></app-skeleton-loader>
          <div class="row">
            <div class="col-md-6 mb-3"><app-skeleton-loader type="rectangle" [height]="40"></app-skeleton-loader></div>
            <div class="col-md-6 mb-3"><app-skeleton-loader type="rectangle" [height]="40"></app-skeleton-loader></div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-3"><app-skeleton-loader type="rectangle" [height]="40"></app-skeleton-loader></div>
            <div class="col-md-6 mb-3"><app-skeleton-loader type="rectangle" [height]="40"></app-skeleton-loader></div>
          </div>
          <div class="row">
            <div class="col-md-12 mb-3"><app-skeleton-loader type="rectangle" [height]="40"></app-skeleton-loader></div>
          </div>
          <app-skeleton-loader type="rectangle" [height]="28" class="mb-3 mt-4" style="max-width: 200px;"></app-skeleton-loader>
          <div class="row">
            <div class="col-md-6 mb-3"><app-skeleton-loader type="rectangle" [height]="40"></app-skeleton-loader></div>
            <div class="col-md-6 mb-3"><app-skeleton-loader type="rectangle" [height]="40"></app-skeleton-loader></div>
          </div>
          <div class="row mt-4" style="margin: 0; justify-content: space-between;">
            <div class="col-6 mb-2"><app-skeleton-loader type="rectangle" [height]="40"></app-skeleton-loader></div>
            <div class="col-6 mb-2"><app-skeleton-loader type="rectangle" [height]="40"></app-skeleton-loader></div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #formContent>
    <div class="card mt-3">
      <div class="card-body">
        <form class="form-sample" [formGroup]="addPersonalInfo">
          <div class="row">
            <div class="col-12">
              <div class="row mt-3" style="margin: 0;">
                <div class="header-players mt-3 mb-4 col-lg-6 p-0">Personal info</div>
              </div>

              <!-- Player contact error (for 13+ players) -->
              <app-field-error id="inv-contact-err"
                [control]="addPersonalInfo"
                [submitted]="submitted"
                [gate]="!!addPersonalInfo.errors?.['playerContactRequired']"
                [messages]="validationMessages.playerContact"
                wrapperClass="col-sm-12 p-0 col-form-label input-group mb-3"></app-field-error>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label" for="inv-email">Email address</label>
                    <div class="col-sm-12">
                      <input type="text" formControlName="email" class="form-control" name="email" id="inv-email"
                        placeholder="email@example.com" (change)="checkUser()"
                        [appAriaField]="addPersonalInfo.controls['email']" ariaDescribedBy="inv-email-err" [submitted]="submitted" />
                      <p style="color: #9b9b9b; font-size: .85rem; margin: 0.2rem;" *ngIf="isUnder13">Leave blank if the child does not have an email.</p>
                    </div>
                    <app-field-error id="inv-email-err" [control]="addPersonalInfo.controls['email']"
                      [submitted]="submitted" [messages]="validationMessages.email"></app-field-error>
                    <div class="col-sm-12 col-form-label input-group pt-2" *ngIf="already_a_academy_member">
                      <small class="text-danger">*Email address is already used by an academy member.</small>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label">Date of birth*</label>
                    <div class="col-sm-12">
                      <mat-form-field appearance="outline" style="width: 100%;">
                        <input matInput [matDatepicker]="picker" readonly placeholder="Select date"
                          (dateChange)="checkAge()" style="font-size: 0.8125rem; padding: .4375rem .75rem;" formControlName="dob">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <app-field-error [control]="addPersonalInfo.controls['dob']" [submitted]="submitted" [messages]="validationMessages.dob"></app-field-error>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label" for="inv-fname">First name*</label>
                    <div class="col-sm-12">
                      <input type="text" class="form-control" (input)="generateUsername()" name="fname" id="inv-fname"
                        placeholder="Enter first name" formControlName="fname"
                        [appAriaField]="addPersonalInfo.controls['fname']" ariaDescribedBy="inv-fname-err" [submitted]="submitted">
                    </div>
                    <app-field-error id="inv-fname-err" [control]="addPersonalInfo.controls['fname']"
                      [submitted]="submitted" [messages]="validationMessages.firstName"></app-field-error>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label">Last name</label>
                    <div class="col-sm-12">
                      <input type="text" class="form-control" (input)="generateUsername()" formControlName="lname" name="lname" placeholder="Enter last name" />
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label" for="inv-username">Username*</label>
                    <div class="col-sm-12">
                      <input type="text" class="form-control" formControlName="username" id="inv-username"
                        (input)="checkUserName()" name="username" placeholder="username"
                        [appAriaField]="addPersonalInfo.controls['username']" ariaDescribedBy="inv-username-err" [submitted]="submitted" />
                    </div>
                    <app-field-error id="inv-username-err" [control]="addPersonalInfo.controls['username']"
                      [submitted]="submitted" [gate]="usernameValid" [messages]="validationMessages.username"></app-field-error>
                    <div class="col-sm-12 col-form-label input-group pt-2" *ngIf="submitted && usernameValid && !addPersonalInfo.controls['username'].invalid">
                      <small class="text-danger">*Username already exists.</small>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label" for="inv-gender">Gender*</label>
                    <div class="col-sm-12">
                      <select class="form-control" formControlName="gender" name="gender" id="inv-gender" style="color: black;"
                        [appAriaField]="addPersonalInfo.controls['gender']" ariaDescribedBy="inv-gender-err" [submitted]="submitted">
                        <option value="" selected hidden>Select gender</option>
                        <option class="gender-drop" value="M">Male</option>
                        <option class="gender-drop" value="F">Female</option>
                        <option class="gender-drop" value="O">Other</option>
                      </select>
                    </div>
                    <app-field-error id="inv-gender-err" [control]="addPersonalInfo.controls['gender']"
                      [submitted]="submitted" [messages]="validationMessages.gender"></app-field-error>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label">Blood group</label>
                    <div class="col-sm-12">
                      <select class="form-control" formControlName="blood_group" style="color: black;">
                        <option value="" selected hidden>Select blood group</option>
                        <option value="O+">O+</option>
                        <option value="O-">O-</option>
                        <option value="A+">A+</option>
                        <option value="A-">A-</option>
                        <option value="B+">B+</option>
                        <option value="B-">B-</option>
                        <option value="AB+">AB+</option>
                        <option value="AB-">AB-</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label">Country code</label>
                    <div class="col-sm-12">
                      <mat-form-field class="example-full-width" appearance="outline">
                        <input type="text" class="main-height" placeholder="Pick a code" aria-label="Phone Number Extension"
                          matInput [formControl]="phoneCodeControlPlayer" [matAutocomplete]="autoPlayer">
                        <mat-autocomplete #autoPlayer="matAutocomplete">
                          @for (option of filteredOptionsPhoneCodesPlayer | async ; track option) {
                            <mat-option [value]="option.dial_code">{{option.dial_code}} ({{option.name}})</mat-option>
                          }
                        </mat-autocomplete>
                      </mat-form-field>
                    </div>
                    <app-field-error [control]="phoneCodeControlPlayer" [submitted]="submitted" [messages]="validationMessages.phoneCode"></app-field-error>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label" for="inv-phonenumber">Phone number (WhatsApp preferred)</label>
                    <div class="col-sm-12">
                      <input class="form-control" formControlName="phonenumber" id="inv-phonenumber"
                        [appPhoneFormat]="phoneCodeControlPlayer.value" placeholder="Enter phone number"
                        [appAriaField]="addPersonalInfo.controls['phonenumber']" ariaDescribedBy="inv-phonenumber-err" [submitted]="submitted" />
                    </div>
                    <app-field-error id="inv-phonenumber-err" [control]="addPersonalInfo.controls['phonenumber']"
                      [submitted]="submitted" [messages]="validationMessages.phoneNumber"></app-field-error>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label">Registration authority</label>
                    <div class="col-sm-12">
                      <select class="form-control" formControlName="reg_authority" style="color: black;">
                        <option value="" selected hidden>Select registration authority</option>
                        <option value="AIFF">AIFF</option>
                        <option value="FIFA">FIFA</option>
                        <option value="USSF">USSF</option>
                        <option value="US Club Soccer">US Club Soccer</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label">Registration number</label>
                    <div class="col-sm-12">
                      <input type="text" class="form-control" formControlName="reg_number"
                        placeholder="Enter registration number" />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Parent/Guardian info -->
              <div class="header-players mt-5 col-lg-6 p-0 mb-0">Parent/Guardian info
                <span *ngIf="isUnder13">(Compulsory)</span>
                <span *ngIf="!isUnder13">(Optional)</span>
              </div>
              <div class="col-sm-12 p-0 col-form-label input-group mb-3">
                <small class="text-danger" *ngIf="isUnder13">*Parent/Guardian name and at least one of email or WhatsApp number are compulsory for players under 13</small>
              </div>
              <app-field-error id="inv-pcontact-err"
                [control]="addPersonalInfo"
                [submitted]="submitted"
                [gate]="!!addPersonalInfo.errors?.['parentContactRequired']"
                [messages]="validationMessages.parentContact"
                wrapperClass="col-sm-12 p-0 col-form-label input-group mb-3"></app-field-error>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label" for="inv-pemail">Email</label>
                    <div class="col-sm-12">
                      <input type="text" class="form-control" formControlName="pemail" id="inv-pemail" placeholder="email@example.com"
                        (change)="checkParentUser()"
                        [appAriaField]="addPersonalInfo.controls['pemail']" ariaDescribedBy="inv-pemail-err" [submitted]="submitted" />
                    </div>
                    <app-field-error id="inv-pemail-err" [control]="addPersonalInfo.controls['pemail']"
                      [submitted]="submitted" [messages]="validationMessages.email"></app-field-error>
                    <div class="col-sm-12 col-form-label input-group pt-2" *ngIf="parent_is_academy && !addPersonalInfo.controls['pemail'].errors?.['email']">
                      <small class="text-danger">{{ validationMessages.parentEmail.academy }}</small>
                    </div>
                    <div class="col-sm-12 col-form-label input-group pt-2" *ngIf="parent_already_a_academy_member && !addPersonalInfo.controls['pemail'].errors?.['email']">
                      <small class="text-danger">{{ validationMessages.parentEmail.member }}</small>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label" for="inv-pfname">First name*</label>
                    <div class="col-sm-12">
                      <input type="text" class="form-control" formControlName="pfname" id="inv-pfname" placeholder="Enter first name"
                        [appAriaField]="addPersonalInfo.controls['pfname']" ariaDescribedBy="inv-pfname-err" [submitted]="submitted" />
                    </div>
                    <app-field-error id="inv-pfname-err" [control]="addPersonalInfo.controls['pfname']"
                      [submitted]="submitted" [messages]="validationMessages.firstName"></app-field-error>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label">Last name</label>
                    <div class="col-sm-12">
                      <input type="text" class="form-control" formControlName="plname" name="plname" placeholder="Enter last name" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label">Country code</label>
                    <div class="col-sm-12">
                      <mat-form-field class="example-full-width" appearance="outline">
                        <input type="text" class="main-height" placeholder="Pick a code" aria-label="Phone Number Extension"
                          matInput [formControl]="phoneCodeControl" [matAutocomplete]="autoParent">
                        <mat-autocomplete #autoParent="matAutocomplete">
                          @for (option of filteredOptionsPhoneCodes | async ; track option) {
                            <mat-option [value]="option.dial_code">{{option.dial_code}} ({{option.name}})</mat-option>
                          }
                        </mat-autocomplete>
                      </mat-form-field>
                    </div>
                    <app-field-error [control]="phoneCodeControl" [submitted]="submitted" [messages]="validationMessages.phoneCode"></app-field-error>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label" for="inv-pphonenumber">Phone number (WhatsApp preferred)</label>
                    <div class="col-sm-12">
                      <input class="form-control" formControlName="pphonenumber" id="inv-pphonenumber"
                        [appPhoneFormat]="phoneCodeControl.value" placeholder="Enter phone number"
                        [appAriaField]="addPersonalInfo.controls['pphonenumber']" ariaDescribedBy="inv-pphonenumber-err" [submitted]="submitted" />
                    </div>
                    <app-field-error id="inv-pphonenumber-err" [control]="addPersonalInfo.controls['pphonenumber']"
                      [submitted]="submitted" [messages]="validationMessages.phoneNumber"></app-field-error>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-sm-12 col-form-label">Relation*</label>
                    <div class="col-sm-12">
                      <select class="form-control" formControlName="prelation" name="prelation" style="color: black;">
                        <option value="Parent">Parent</option>
                        <option value="Guardian">Guardian</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Licenses & Certificates -->
              <div class="row mt-2">
                <div class="col-12">
                  <div class="header-players mt-1 mb-5 col-lg-6 p-0">Licenses &amp; Certificates (Optional)</div>
                  <div class="uploading-contain col-12 mb-5">
                    <div class="media-container-empty" (click)="openMediumModal(exampleModalContent)">
                      <div class="upload-contain">
                        <img src="images/icons/upload.png" style="height: 2rem;">
                        <span class="primary-text bd-7">Upload your file</span>
                        <span class="primary-text">Files supported: JPG, PNG, PDF</span>
                      </div>
                    </div>
                    <div class="col-12 p-0 middle" *ngIf="licenseList.length > 0" style="max-height: 300px; overflow: auto;">
                      <div class="media-container col-12" style="cursor: pointer;" *ngFor="let license of licenseList; let i = index">
                        <div class="class-text d-flex">
                          <div (click)="openAttachment(license.path)" class="d-flex col-7 p-0 over-flow-word">
                            <span><img src="images/icons-svg/dartle_emblem.svg" class="dartle-logo"></span>
                            <span class="class-text-name mb-2 over-flow-word" [title]="license.name">{{license.name}}</span>
                          </div>
                          <div class="col-5 media-delete">
                            <img src="images/icons/remove_circle.png" [swal]="warningWithCancel" style="width: 24px; height: 28px;">
                          </div>
                          <swal #warningWithCancel type="warning" title="Are you sure?" confirmButtonText="Confirm"
                            text="Do you want to remove this attachment" [showCancelButton]="true"
                            cancelButtonClass="btn btn-outline-dark" (confirm)="removeAttachment(license.path)">
                          </swal>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Additional info (Optional) -->
                  <div class="row mb-3 mt-3" *ngIf="show_additional_info">
                    <div class="col-12 mb-3 d-flex pe-5" style="gap: 2rem;">
                      <div class="col-lg-10 d-flex flex-column p-0 fit-width" style="height: fit-content; gap: 2rem; max-height: 600px; overflow: auto;" #leftContainer>
                        <!-- Jersey -->
                        <div id="card1" #card1 class="col-lg-12 p-0">
                          <div class="card"><div class="card-body">
                            <div class="header-players mt-1 mb-4 col-lg-6 p-0">Jersey information</div>
                            <form class="form-sample" [formGroup]="addJerseyInfo">
                              <div class="row show-style">
                                <div class="col-md-4">
                                  <span>T-shirt size (Optional)</span>
                                  <div class="form-group row mt-2"><div class="col-sm-12">
                                    <select class="form-control form-boxes" formControlName="t_shirt_size" name="t_shirt_size" style="color: black;">
                                      <option value="" hidden style="opacity: 0.8;">Select size</option>
                                      <option *ngFor="let size of ['XS','S','M','L','XL','XXL','XXXL']" [value]="size">{{ size }}</option>
                                    </select>
                                  </div></div>
                                </div>
                                <div class="col-md-4">
                                  <span>Shorts size (Optional)</span>
                                  <div class="form-group row mt-2"><div class="col-sm-12">
                                    <select class="form-control form-boxes" formControlName="shorts_size" name="shorts_size" style="color: black;">
                                      <option value="" hidden style="opacity: 0.8;">Select size</option>
                                      <option *ngFor="let size of ['XS','S','M','L','XL','XXL','XXXL']" [value]="size">{{ size }}</option>
                                    </select>
                                  </div></div>
                                </div>
                                <div class="col-md-4">
                                  <span>Shoe size (Optional)</span>
                                  <div class="form-group row mt-2"><div class="col-sm-12">
                                    <input type="number" class="form-control form-boxes" formControlName="shoe_size" name="shoe_size" min="0"
                                      oninput="this.value = this.value < 0 ? 0 : this.value" placeholder="Enter shoe size">
                                  </div></div>
                                </div>
                              </div>
                            </form>
                          </div></div>
                        </div>
                        <!-- Physical -->
                        <div id="card2" #card2 class="col-lg-12 p-0">
                          <div class="card"><div class="card-body">
                            <div class="header-players mt-1 mb-4 col-lg-6 p-0">Physical characteristics</div>
                            <form class="form-sample" [formGroup]="addPhysicalChara">
                              <div class="row show-style">
                                <div class="col-md-4"><span>Height (Optional)</span>
                                  <div class="form-group row mt-2"><div class="col-sm-12">
                                    <input type="number" class="form-control form-boxes" formControlName="height" placeholder="cm" min="0" maxlength="3" />
                                  </div></div>
                                </div>
                                <div class="col-md-4"><span>Weight (Optional)</span>
                                  <div class="form-group row mt-2"><div class="col-sm-12">
                                    <input type="number" class="form-control form-boxes" formControlName="weight" placeholder="kg" min="0" maxlength="3" />
                                  </div></div>
                                </div>
                                <div class="col-md-4"><span>BMI (Optional)</span>
                                  <div class="form-group row mt-2"><div class="col-sm-12">
                                    <input type="text" class="form-control form-boxes" formControlName="bmi" placeholder="kg/m²" readonly />
                                  </div></div>
                                </div>
                              </div>
                            </form>
                          </div></div>
                        </div>
                        <!-- Sport -->
                        <div id="card3" #card3 class="col-lg-12 p-0">
                          <div class="card"><div class="card-body">
                            <div class="header-players mt-1 mb-4 col-lg-6 p-0">Sport information</div>
                            <form class="form-sample" [formGroup]="addSportInfo">
                              <div class="row show-style">
                                <div class="col-md-6"><span>Sport</span>
                                  <div class="form-group row mt-2"><div class="col-sm-12">
                                    <select class="form-control" formControlName="sport_name" name="sport_name" style="color: black;">
                                      <option value="" selected hidden>Select sport</option>
                                      <option class="gender-drop" *ngFor="let sport of sportsList" [value]="sport._id">
                                        {{ sport.sports | string : 'sentence' }}
                                        @if (sport.alias) { ({{sport.alias}}) }
                                      </option>
                                    </select>
                                  </div></div>
                                </div>
                                <div class="col-md-6"><span>Position</span>
                                  <div class="form-group row mt-2"><div class="col-sm-12">
                                    <input type="text" formControlName="position" class="form-control form-boxes" name="position" placeholder="Enter position" />
                                  </div></div>
                                </div>
                              </div>
                            </form>
                          </div></div>
                        </div>
                        <!-- Address -->
                        <div id="card4" #card4 class="col-lg-12 p-0">
                          <div class="card"><div class="card-body">
                            <div class="header-players mt-1 mb-4 col-lg-6 p-0">Address information</div>
                            <form class="form-sample" [formGroup]="addAddressInfo">
                              <div class="mb-2ss"><span>Country</span>
                                <div class="form-group row mt-2"><div class="col-sm-12">
                                  <div ngbDropdown>
                                    <button class="btn form-control btn-outline-dark" type="button" ngbDropdownToggle
                                      style="text-align: left;padding: 0rem 1rem;border: 1px solid #ced4da;">{{countryName}}</button>
                                    <div ngbDropdownMenu style="min-width: 100%;">
                                      <input type="text" class="form-control filter-search" [(ngModel)]="searchTerm"
                                        [ngModelOptions]="{standalone: true}" placeholder="Country name" (input)="search()" />
                                      <div>
                                        <div class="dropdown-item filter-elem" *ngFor="let elem of countryList | slice:0:25;" (click)="selectCountry(elem)">{{elem.country}}</div>
                                      </div>
                                    </div>
                                  </div>
                                </div></div>
                              </div>
                              <div class="row show-style">
                                <div class="col-md-6"><span>Address</span>
                                  <div class="form-group row mt-2"><div class="col-sm-12">
                                    <input type="text" formControlName="address" class="form-control form-boxes" placeholder="Enter address" />
                                  </div></div>
                                </div>
                                <div class="col-md-6"><span>County/Province/State</span>
                                  <div class="form-group row mt-2"><div class="col-sm-12">
                                    <div ngbDropdown>
                                      <button class="btn form-control btn-outline-dark" type="button" ngbDropdownToggle
                                        style="text-align: left;padding: 0rem 1rem;border: 1px solid #ced4da;">{{stateName}}</button>
                                      <div ngbDropdownMenu style="min-width: 100%;">
                                        <input type="text" class="form-control filter-search" [(ngModel)]="searchTermState"
                                          [ngModelOptions]="{standalone: true}" placeholder="State name" (input)="searchState()" />
                                        <div>
                                          <div class="dropdown-item filter-elem" *ngFor="let elem of stateList" (click)="selectState(elem)">{{elem}}</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div></div>
                                </div>
                              </div>
                              <div class="row show-style">
                                <div class="col-md-6"><span>City</span>
                                  <div class="form-group row mt-2"><div class="col-sm-12">
                                    <input type="text" class="form-control" formControlName="city" name="city" placeholder="Enter city" />
                                  </div></div>
                                </div>
                                <div class="col-md-6"><span>Postal code</span>
                                  <div class="form-group row mt-2"><div class="col-sm-12">
                                    <div ngbDropdown>
                                      <button class="btn form-control btn-outline-dark" type="button" ngbDropdownToggle
                                        style="text-align: left;padding: 0rem 1rem;border: 1px solid #ced4da;">{{pincodeName}}</button>
                                      <div ngbDropdownMenu style="min-width: 100%;">
                                        <input type="text" class="form-control filter-search" [(ngModel)]="searchTermPincode"
                                          [ngModelOptions]="{standalone: true}" placeholder="Search postal code" (input)="searchPostcode()" />
                                        <div>
                                          <div class="dropdown-item filter-elem" *ngFor="let elem of pincodeList | slice:0:25;" (click)="selectPostcode(elem)">{{elem}}</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div></div>
                                </div>
                              </div>
                            </form>
                          </div></div>
                        </div>
                        <!-- Education -->
                        <div id="card5" #card5 class="col-lg-12 p-0">
                          <div class="card"><div class="card-body">
                            <div class="header-players mt-1 mb-4 col-lg-6 p-0">Education history</div>
                            <div class="card p-3 mb-5">
                              <form class="form-sample" [formGroup]="addEducation">
                                <span>Education institute*</span>
                                <div class="form-group row mt-2" style="margin-bottom: 0rem;"><div class="col-sm-12">
                                  <input type="text" formControlName="institute" class="form-control form-boxes" placeholder="Institute name" />
                                </div></div>
                                <div class="row mt-3 mb-3 show-style">
                                  <div class="col-md-6"><span>Discipline*</span>
                                    <div class="form-group row mt-2"><div class="col-sm-12">
                                      <input type="text" formControlName="discipline" class="form-control form-boxes" placeholder="Enter discipline" />
                                    </div></div>
                                  </div>
                                  <div class="col-md-3"><span>Start year*</span>
                                    <div class="form-group row mt-2"><div class="col-sm-12">
                                      <input type="number" min="1900" formControlName="start_Year" class="form-control form-boxes" placeholder="Start year" maxlength="4" />
                                    </div></div>
                                  </div>
                                  <div class="col-md-3"><span>End year*</span>
                                    <div class="form-group row mt-2"><div class="col-sm-12">
                                      <input type="number" min="1901" formControlName="end_Year" class="form-control form-boxes" placeholder="End year" maxlength="4" />
                                      <div *ngIf="addEducation.errors?.startYearLessThanEndYear" class="text-danger">*End year must be after start year</div>
                                    </div></div>
                                  </div>
                                </div>
                                <div class="col-md-3 p-0"><div class="form-group row"><div class="col-sm-12">
                                  <button matRipple type="button" class="btn btn-primary main-height" [disabled]="!checkFormValidity()" (click)="createEducation()"
                                    style="width: inherit; padding: 0.8rem 3rem; min-width: 10rem;">Save</button>
                                </div></div></div>
                              </form>
                            </div>
                            <div class="card p-4" *ngIf="educationList.length > 0" style="background: #F7F7F7;">
                              <span class="header-players ml-4">Education history</span>
                              <div class="col-12 mt-3 mb-3"><div class="row">
                                <div class="col-md-6 show-style" *ngFor="let educations of educationList; let i=index">
                                  <div class="education-box">
                                    <div style="float: right; cursor: pointer;" (click)="removeEducation(i)">
                                      <img src="images/icons/remove_circle.png" style="width: 24px; height: 28px;">
                                    </div>
                                    <div class="d-flex">
                                      <img class="mt-1" src="images/icons/school.png" style="width: 24px; height: 28px;">
                                      <div class="ms-2 over-flow-word" style="padding: .3rem;">
                                        <div class="text-bold mb-1 over-flow-word" style="text-transform: capitalize; color: #FF6634;">{{educations.institute}}</div>
                                        <div class="text-base f-bold mb-1 over-flow-word" style="color: #959595;">{{educations.discipline | string : 'sentence'}}</div>
                                        <div class="text-bold mb-1">{{educations.start_date}} - {{educations.end_date}}</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div></div>
                            </div>
                          </div></div>
                        </div>
                        <!-- Career -->
                        <div id="card6" #card6 class="col-lg-12 p-0">
                          <div class="card"><div class="card-body">
                            <div class="header-players mt-1 mb-4 col-lg-6 p-0">Career history</div>
                            <div class="card p-3 mb-5">
                              <form class="form-sample" [formGroup]="addCareer">
                                <span>Academy*</span>
                                <div class="form-group row mt-2" style="margin-bottom: 0rem;"><div class="col-sm-12">
                                  <input type="text" formControlName="academy" class="form-control form-boxes" placeholder="Academy name" />
                                </div></div>
                                <div class="row mt-3 mb-3 show-style">
                                  <div class="col-md-6"><span>Role*</span>
                                    <div class="form-group row mt-2"><div class="col-sm-12">
                                      <input type="text" formControlName="role" class="form-control form-boxes" placeholder="Enter role" />
                                    </div></div>
                                  </div>
                                  <div class="col-md-3"><span>Start date*</span>
                                    <div class="form-group row mt-2"><div class="col-sm-12">
                                      <mat-form-field appearance="outline" style="width: 100%;">
                                        <input matInput [matDatepicker]="picker1" readonly placeholder="Select date"
                                          style="font-size: 0.8125rem; padding: .4375rem .75rem;" formControlName="start_date">
                                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                        <mat-datepicker #picker1></mat-datepicker>
                                      </mat-form-field>
                                    </div></div>
                                  </div>
                                  <div class="col-md-3"><span>End date*</span>
                                    <div class="form-group row mt-2"><div class="col-sm-12">
                                      <mat-form-field appearance="outline" style="width: 100%;">
                                        <input matInput [matDatepicker]="picker2" readonly placeholder="Select date"
                                          style="font-size: 0.8125rem; padding: .4375rem .75rem;" formControlName="end_date">
                                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                        <mat-datepicker #picker2></mat-datepicker>
                                      </mat-form-field>
                                      <div *ngIf="addCareer.errors?.startDateBeforeEndDate" class="text-danger">*End date must be after start date</div>
                                    </div></div>
                                  </div>
                                </div>
                                <div class="col-md-3 p-0"><div class="form-group row"><div class="col-sm-12">
                                  <button matRipple type="button" class="btn btn-primary main-height" [disabled]="!checkCareerValidity()" (click)="createCareer()"
                                    style="width: inherit; padding: 0.8rem 3rem; min-width: 10rem;">Save</button>
                                </div></div></div>
                              </form>
                            </div>
                            <div class="card p-4" *ngIf="careerList.length > 0" style="background: #F7F7F7;">
                              <span class="header-players ml-4">Career history</span>
                              <div class="col-12 mt-3 mb-3"><div class="row">
                                <div class="col-md-6 show-style" *ngFor="let career of careerList; let i=index">
                                  <div class="education-box">
                                    <div style="float: right; cursor: pointer;" (click)="removeCareer(i)">
                                      <img src="images/icons/remove_circle.png" style="width: 24px; height: 28px;">
                                    </div>
                                    <div class="d-flex">
                                      <img class="mt-1" src="images/icons/work.png" style="width: 24px; height: 28px;">
                                      <div class="ms-2 over-flow-word" style="padding: .3rem;">
                                        <div class="text-bold mb-1 over-flow-word" style="text-transform: capitalize; color: #FF6634;">{{career.academy_name}}</div>
                                        <div class="text-base f-bold mb-1 over-flow-word" style="color: #959595;">{{career.role | string: 'sentence'}}</div>
                                        <div class="text-bold mb-1">{{ career.start_date | dateTime: 'MMMM yyyy' }} - {{ career.end_date | dateTime: 'MMM yyyy' }}</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div></div>
                            </div>
                          </div></div>
                        </div>
                        <!-- Achievements -->
                        <div id="card7" #card7 class="col-lg-12 p-0">
                          <div class="card"><div class="card-body">
                            <div class="header-players mt-1 mb-4 col-lg-6 p-0">Achievements</div>
                            <div class="card p-3 mb-5">
                              <form class="form-sample" [formGroup]="addAchievement">
                                <span>Event*</span>
                                <div class="form-group row mt-2" style="margin-bottom: 0rem;"><div class="col-sm-12">
                                  <input type="text" formControlName="event" class="form-control form-boxes" name="event" placeholder="Event name" />
                                </div></div>
                                <div class="row mt-3 mb-3 show-style">
                                  <div class="col-md-6"><span>Achievement*</span>
                                    <div class="form-group row mt-2"><div class="col-sm-12">
                                      <input type="text" formControlName="achievement" class="form-control form-boxes" name="achievement" placeholder="Enter achievement" />
                                    </div></div>
                                  </div>
                                  <div class="col-md-6"><span>Year*</span>
                                    <div class="form-group row mt-2"><div class="col-sm-12">
                                      <input type="number" min="1900" formControlName="year" class="form-control form-boxes" placeholder="Year" maxlength="4" />
                                    </div></div>
                                  </div>
                                </div>
                                <div class="col-md-3 p-0"><div class="form-group row"><div class="col-sm-12">
                                  <button matRipple type="button" class="btn btn-primary main-height" [disabled]="!checkAchievementValidity()" (click)="saveAchievement()"
                                    style="width: inherit; padding: 0.8rem 3rem; min-width: 10rem;">Save</button>
                                </div></div></div>
                              </form>
                            </div>
                            <div class="card p-4" *ngIf="achievementList.length > 0" style="background: #F7F7F7;">
                              <span class="header-players ml-4">Achievement list</span>
                              <div class="col-12 mt-3 mb-3"><div class="row">
                                <div class="col-md-6 show-style" *ngFor="let achieve of achievementList; let i=index">
                                  <div class="education-box">
                                    <div style="float: right; cursor: pointer;" (click)="removeAchievement(i)">
                                      <img src="images/icons/remove_circle.png" style="width: 24px; height: 28px;">
                                    </div>
                                    <div class="d-flex">
                                      <img class="mt-1" src="images/icons/stars.png" style="width: 24px; height: 28px;">
                                      <div class="ms-2 over-flow-word" style="padding: .3rem;">
                                        <div class="text-bold mb-1 over-flow-word" style="text-transform: capitalize; color: #FF6634;">{{achieve.event_name}}</div>
                                        <div class="text-base f-bold mb-1 over-flow-word" style="color: #959595;">{{achieve.achievement | string:'sentence'}}</div>
                                        <div class="text-bold mb-1">{{achieve.date}}</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div></div>
                            </div>
                          </div></div>
                        </div>
                      </div>

                      <div class="web-show h-100 col-lg-2 p-0 show-selection">
                        <div class="card d-flex flex-column p-0" style="height: 600px;">
                          <div class="text-selection-box" (click)="scrollToCard('card1')">Jersey information</div>
                          <div class="text-selection-box" (click)="scrollToCard('card2')">Physical characteristics</div>
                          <div class="text-selection-box" (click)="scrollToCard('card3')">Sport information</div>
                          <div class="text-selection-box" (click)="scrollToCard('card4')">Address information</div>
                          <div class="text-selection-box" (click)="scrollToCard('card5')">Education history</div>
                          <div class="text-selection-box" (click)="scrollToCard('card6')">Career history</div>
                          <div class="text-selection-box" (click)="scrollToCard('card7')">Achievements</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3" style="margin: 0;">
                    <div class="additional-players mt-1 mb-4 col-lg-6 p-0" (click)="showAdditional()">Additional info (Optional)
                      <i [class]="show_additional_info ? 'bi bi-chevron-up' : 'bi bi-chevron-down'" style="font-size: 1rem;"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

        <!-- Next / Cancel -->
        <div class="row mt-4 last-mob" style="margin: 0; justify-content: space-between;">
          <div class="col-6 p-0 last-full mb-3">
            <button matRipple type="button" (click)="cancelRegistration()"
              class="btn bd-7 btn-outline-primary wizard-btn">
              Cancel registration
            </button>
          </div>
          <div class="col-6 p-0 last-full mb-3" style="display: flex; justify-content: flex-end;">
            <button matRipple type="button" (click)="goToSubscriptions()"
              class="btn bd-7 btn-primary wizard-btn">
              Next step
            </button>
          </div>
        </div>
      </div>
    </div>
    </ng-template>
  </div>

  <!-- ============================ STEP 2 — SUBSCRIPTION SELECTION ============================ -->
  <div class="subs-wrap" *ngIf="current_step === 2 && !inviteInvalid && !alreadyCompleted">
    <h2 class="subs-title">Choose your training plan</h2>
    <p class="subs-sub">Select the perfect plan for {{ invite_child ? (invite_child | titlecase) : 'your child' }}</p>

    <ng-container *ngIf="loadingSubscriptions; else subsContent">
      <div class="subs-grid">
        <div *ngFor="let i of [1,2,3]" class="plan-card-skeleton">
          <!-- Plan name -->
          <app-skeleton-loader type="rectangle" [height]="28" style="max-width: 60%; margin: 0 auto 0.75rem;"></app-skeleton-loader>
          <!-- Plan price -->
          <app-skeleton-loader type="rectangle" [height]="40" style="max-width: 50%; margin: 0 auto 0.35rem;"></app-skeleton-loader>
          <!-- Plan commitment -->
          <app-skeleton-loader type="line" [height]="16" style="max-width: 65%; margin: 0 auto 1.25rem;"></app-skeleton-loader>
          <!-- Feature 1 -->
          <app-skeleton-loader type="line" [height]="18" style="margin-bottom: 0.75rem;"></app-skeleton-loader>
          <!-- Feature 2 -->
          <app-skeleton-loader type="line" [height]="18" style="margin-bottom: 0.75rem;"></app-skeleton-loader>
          <!-- Feature 3 -->
          <app-skeleton-loader type="line" [height]="18" style="margin-bottom: 1.5rem;"></app-skeleton-loader>
          <!-- Select button -->
          <app-skeleton-loader type="rectangle" [height]="44" style="margin-top: auto;"></app-skeleton-loader>
        </div>
      </div>
    </ng-container>

    <ng-template #subsContent>
    <div class="subs-empty" *ngIf="!loadingSubscriptions && subscriptionPlans.length === 0">
      No subscriptions are available for this plan.
    </div>

    <!-- Carousel wrapper -->
    <div class="carousel-wrapper" *ngIf="subscriptionPlans.length > 0">
      <!-- Left arrow (prev) -->
      <button *ngIf="subscriptionPlans.length > 3" type="button" class="carousel-arrow carousel-prev"
        [disabled]="!canCarouselPrev()" (click)="carouselPrev()" [class.disabled]="!canCarouselPrev()">
        <i class="bi bi-chevron-left"></i>
      </button>

      <!-- Cards grid (shows 3 at a time) -->
      <div class="subs-grid">
        <div class="plan-card" *ngFor="let sub of visibleCards()"
          [class.selected]="selectedSubscription?.id === sub.id" (click)="selectSubscription(sub)">
          <div class="plan-header">
            <div class="plan-name">{{ sub.name }}</div>
          </div>
          <div class="plan-price">{{ sub.amount | currencyLocale: locale.currency : locale.currency_format : locale.locale }}</div>
          <div class="plan-per">{{ sub.commitment }}</div>

          <ul class="plan-features" *ngIf="visibleFeatures(sub).length">
            <li *ngFor="let feature of visibleFeatures(sub)">
              <i class="bi bi-check-circle-fill"></i><span>{{ feature }}</span>
            </li>
          </ul>

          <!-- View more button for expanded features -->
          <button *ngIf="hasMoreFeatures(sub) && !isCardExpanded(sub.id)" type="button" class="view-more-btn"
            (click)="toggleCardExpand(sub.id); $event.stopPropagation()">
            View more
          </button>
          <button *ngIf="hasMoreFeatures(sub) && isCardExpanded(sub.id)" type="button" class="view-more-btn"
            (click)="toggleCardExpand(sub.id); $event.stopPropagation()">
            View less
          </button>

          <button matRipple type="button" class="plan-select-btn"
            [class.selected]="selectedSubscription?.id === sub.id">
            {{ selectedSubscription?.id === sub.id ? 'Selected ✓' : 'Select plan' }}
          </button>
        </div>
      </div>

      <!-- Right arrow (next) -->
      <button *ngIf="subscriptionPlans.length > 3" type="button" class="carousel-arrow carousel-next"
        [disabled]="!canCarouselNext()" (click)="carouselNext()" [class.disabled]="!canCarouselNext()">
        <i class="bi bi-chevron-right"></i>
      </button>
    </div>

    <div class="subs-actions">
      <button matRipple type="button" class="btn btn-outline-primary wizard-btn" (click)="cancelRegistration()">Cancel registration</button>
      <button matRipple type="button" class="btn btn-primary wizard-btn" (click)="continueToPayment()">Continue to payment →</button>
    </div>
    </ng-template>
  </div>

  <!-- ============================ STEP 3 — PAYMENT ============================ -->
  <div class="pay-wrap" *ngIf="current_step === 3 && !inviteInvalid && !alreadyCompleted">
    <h2 class="subs-title">Complete payment</h2>
    <p class="subs-sub">Secure your spot at {{ academy_name ? (academy_name | titlecase) : 'the Academy' }}</p>

    <div class="pay-card text-center py-5" *ngIf="isProcessingPayment">
      <div class="pay-card-title">Confirming your payment…</div>
      <p class="pay-sub-note mb-0">Please don't close this window.</p>
    </div>

    <ng-container *ngIf="!isProcessingPayment">
      <!-- If academy has not linked a payment processor, show offline payment message instead -->
      <ng-container *ngIf="academyPaymentOnboarded === false">
        <div class="pay-card">
          <div class="pay-card-title">Amount to pay at academy</div>

          <div class="pay-plan-header">
            <div class="pay-plan-info">
              <span class="pay-plan-name">{{ selectedSubscription?.name | string: 'sentence' }}</span>
              <span class="pay-plan-commitment">{{ selectedSubscription?.commitment }}</span>
            </div>
            <span class="pay-plan-price">{{ selectedSubscription?.amount | currencyLocale: locale.currency : locale.currency_format : locale.locale }}</span>
          </div>

          <hr />

          <p class="pay-sub-note mb-0">
            This academy hasn't enabled online payments yet. Please complete your membership payment directly at the academy.
            Once your payment is confirmed, reopen this link to set up your password.
          </p>
        </div>
      </ng-container>

      <!-- Show payment UI only if academy is onboarded (or still checking) -->
      <ng-container *ngIf="academyPaymentOnboarded !== false">
        <div class="pay-card">
          <div class="pay-card-title">Order summary</div>

          <div class="pay-plan-header">
            <div class="pay-plan-info">
              <span class="pay-plan-name">{{ selectedSubscription?.name | string: 'sentence' }}</span>
              <span class="pay-plan-commitment">{{ selectedSubscription?.commitment }}</span>
            </div>
            <span class="pay-plan-price">{{ selectedSubscription?.amount | currencyLocale: locale.currency : locale.currency_format : locale.locale }}</span>
          </div>

        <ng-container *ngIf="isIndiaAcademy && orderPreview">
          <!-- For inclusive-of-charges plans, show the breakdown starting from base amount so it adds up -->
          <div class="pay-row" *ngIf="orderPreview.base_amount_excluding_gst">
            <span>Base amount</span>
            <span>{{ orderPreview.base_amount_excluding_gst | currencyLocale: locale.currency : locale.currency_format : locale.locale }}</span>
          </div>
          <div class="pay-row" *ngIf="orderPreview.discount > 0">
            <span>Discount</span>
            <span class="text-danger">-{{ orderPreview.discount | currencyLocale: locale.currency : locale.currency_format : locale.locale }}</span>
          </div>
          <div class="pay-row" *ngIf="orderPreview.dartle_fee > 0">
            <span>Dartle fee</span>
            <span>{{ orderPreview.dartle_fee | currencyLocale: locale.currency : locale.currency_format : locale.locale }}</span>
          </div>
          <div class="pay-row" *ngIf="orderPreview.processor_fee > 0">
            <span>Processing fee</span>
            <span>{{ orderPreview.processor_fee | currencyLocale: locale.currency : locale.currency_format : locale.locale }}</span>
          </div>
          <div class="pay-row" *ngIf="orderPreview.gst_amount > 0">
            <span>GST ({{ orderPreview.gst_percentage }}%)</span>
            <span>{{ orderPreview.gst_amount | currencyLocale: locale.currency : locale.currency_format : locale.locale }}</span>
          </div>
        </ng-container>
        <p class="pay-sub-note mb-0 mt-2" *ngIf="isIndiaAcademy && loadingOrderPreview">Calculating breakdown…</p>

        <hr />
        <div class="pay-row total">
          <span>Total</span>
          <span class="amount-gradient">{{ displayTotal | currencyLocale: locale.currency : locale.currency_format : locale.locale }}</span>
        </div>
      </div>

      <div class="pay-card">
        <div class="pay-card-title">Select payment method</div>

        <p class="pay-sub-note" *ngIf="loadingPaymentPortals">Loading available payment methods…</p>

        <ng-container *ngIf="!loadingPaymentPortals">
          <div role="radiogroup" aria-label="Payment method" *ngIf="availablePaymentPortals.length">
            <div class="pay-method" *ngFor="let portal of availablePaymentPortals"
              role="radio" [attr.aria-checked]="selectedPortal === portal" tabindex="0"
              [class.selected]="selectedPortal === portal" (click)="selectPaymentMethod(portal)"
              (keydown.enter)="selectPaymentMethod(portal)"
              (keydown.space)="$event.preventDefault(); selectPaymentMethod(portal)">
              <img *ngIf="portal.payment_info?.detail?.icon; else fallbackIcon" [src]="portal.payment_info.detail.icon" alt="" class="pay-method-icon">
              <ng-template #fallbackIcon><i class="bi bi-credit-card-2-front"></i></ng-template>
              <div><div class="pay-method-name">{{ portal.payment_info?.name }}</div></div>
              <i class="bi bi-check-circle-fill pay-method-check" *ngIf="selectedPortal === portal"></i>
            </div>
          </div>
          <p class="pay-sub-note mb-0" *ngIf="!availablePaymentPortals.length">
            No payment methods are available for this academy yet. Please contact them directly.
          </p>
        </ng-container>
      </div>

      <div class="subs-actions">
        <button matRipple type="button" class="btn btn-outline-primary wizard-btn" (click)="backToSubscriptions()">← Back</button>
        <button matRipple type="button" class="btn btn-primary wizard-btn" [disabled]="!availablePaymentPortals.length || (isIndiaAcademy && loadingOrderPreview)" (click)="confirmAndPay()">Confirm &amp; pay</button>
      </div>
      </ng-container>
    </ng-container>
  </div>

  <!-- ============================ STEP 4 — CONFIRMATION ============================ -->
  <div *ngIf="current_step === 4 && !inviteInvalid && !alreadyCompleted">
    <app-registration-confirmation
      mode="set-password"
      [name]="invite_child"
      [passwordLink]="passwordSetupLink"
      [passwordLinkLoading]="passwordLinkLoading"
      [passwordLinkError]="passwordLinkError">
    </app-registration-confirmation>
  </div>

  <!-- Upload modal (reused from self-registration) -->
  <ng-template class="modal fade" #exampleModalContent let-modal>
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-between col-12" style="padding: 1rem 2rem;">
        <h5 class="modal-title mt-2 bd-7"><span>Upload file</span></h5>
        <img class="close model-close" aria-label="Close" (click)="modal.dismiss()" src="images/icons/cancel.png">
      </div>
      <input type="file" (change)="fileChangeEvent($event)" #myfileid id="myfileid" style="display: none;" />
      <div class="modal-body col-12">
        <div class="w-100 d-flex justify-content-center pt-5 pb-5" *ngIf="fileSelect" (click)="openFileSelect()">
          <img src="images/samples/ic_add_image.png" />
        </div>
        <div class="w-100 d-flex justify-content-center pt-5 pb-5" *ngIf="fileSelectDone || afterImageUpload" (click)="openFileSelect()">
          <img src="images/icons/ic_success_full.png" alt="" />
        </div>
      </div>
      <div class="modal-footer col-12">
        <button matRipple type="button" class="btn btn-dark al-start alert-footer main-height" (click)="openFileSelect()">Choose file</button>
        <button matRipple type="button" class="btn btn-success alert-footer main-height" (click)="uploadAttachment();">Upload</button>
        <button matRipple type="button" class="btn btn-light alert-footer main-height" (click)="modal.dismiss()">Cancel</button>
      </div>
    </div>
  </ng-template>

</div>
